import { css } from "@emotion/react";

export const styles = {
  slider__button: css`
    @media (max-width: 899px) {
      flex: 1;
      align-items: end;
    }
  `,

  box__typography: css`
    background-color: #ffc700;
    border-radius: 4px;
  `,

  box__button: css`
    text-transform: none;
    font-weight: 600;
    font-size: 16px;
    color: #d5d5d5;
    border-radius: 6px;
    padding: 16px 36px;

    @media (max-width: 899px) {
      width: 222px;
    }
  `,
  box__logo: css`
    @media (max-width: 899px) {
      height: 82px;
      width: 163px;
    }
  `
};
